import React from 'react';
import { makeStyles, lighten } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

export default function CalcTable({id, cols, rows, header, additionalRow, customPaperMargin, offBottomSpacing}) {
  const useStyles = makeStyles({
    tableContainer: {
      padding: offBottomSpacing ? 0 : "0 0 15px 0",
      minHeight: 188
    },
    fontBold: {
      fontWeight: 700
    },
    cellRed: {
      color: 'red',
      fontWeight: 700
    },
    cellGreen: {
      color: 'green',
      fontWeight: 700
    },
    customPaperMargin: {
      margin: "0 0 50px 0",
    },
  });
  const classes = useStyles();
  const useToolbarStyles = makeStyles((theme) => ({
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
    },
    highlight:
      theme.palette.type === 'light'
        ? {
            color: theme.palette.secondary.main,
            backgroundColor: lighten(theme.palette.secondary.light, 0.85),
          }
        : {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.secondary.dark,
          },
    title: {
      flex: '1 1 100%',
      fontWeight: 700,
      lineHeight: "1.118"
    },
  }));

  const EnhancedTableToolbar = ({header}) => {
    const classes = useToolbarStyles();
  
    return (
      <Toolbar
        className={classes.root}
      >
        <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
            {header}
        </Typography>
      </Toolbar>
    );
  };

  return (
    <TableContainer id={id} component={Paper} className={`${classes.tableContainer} ${customPaperMargin ? classes.customPaperMargin : ''}`}>
      {header && <EnhancedTableToolbar header={header}/>}
      <Table className={classes.table} aria-label={id}>
        <TableHead>
          <TableRow>
            {
              cols.map((col) => (
                <TableCell key={col}>{col}</TableCell>
              ))
            }
          </TableRow>
        </TableHead>
        <TableBody>
              {rows.map((rowObj, i) => {
                return (
                  <TableRow key={i}>
                    {Object.keys(rowObj).map((row, i) => (
                      <TableCell key={i}>
                        {rowObj[row]}
                      </TableCell>
                    ))}
                  </TableRow>
                )
              })}
              {
                additionalRow && (
                  <TableRow>
                    <TableCell rowSpan={6} className={classes.fontBold}>{additionalRow.name}</TableCell>
                    <TableCell rowSpan={6} align="right" className={additionalRow.isNegative ? classes.cellRed : classes.cellGreen}>{additionalRow.value}</TableCell>
                  </TableRow>
                )
              }
        </TableBody>
      </Table>
    </TableContainer>
  );
}
